import CityLanding from "@/pages/CityLanding";

const CITY = {
    slug: "jacksonville",
    name: "Jacksonville",
    shortName: "Jax",
    zipHint: "Duval County — 32202 to 32277",
    landmarkPhrase: "your home, office, or a hotel suite near the St. Johns River",
    introCopy:
        "From Riverside brunches to Ponte Vedra weddings, we bring the studio to you. Two monthly plans, unlimited visits, AI-designed nail art, and same-day booking before 6pm across the Bold City.",
    whyCopy:
        "Between Downtown Jacksonville traffic and busy Southbank calendars, driving to a nail salon is time you don't have. Our mobile studio meets you where you already are — your living room in San Marco, your event suite at the Riverside Arts Market, or a bridal party in Ponte Vedra Beach. Every visit includes patent-pending AI 3D nail art, and our subscribers never pay per set.",
    neighborhoods: [
        "Riverside",
        "San Marco",
        "Ponte Vedra",
        "Southside",
        "Mandarin",
        "Avondale",
        "Downtown",
        "Jacksonville Beach",
    ],
    nearby: ["Atlantic Beach", "Neptune Beach", "Nocatee", "Fleming Island"],
};

export default function Jacksonville() {
    return <CityLanding city={CITY} />;
}
